import React, {useCallback, useReducer, useState} from "react";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Box from "@amzn/meridian/box";
import Loader from "@amzn/meridian/loader";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Button from "@amzn/meridian/button";
import {DepartureSheetResponse} from "./DepartureSheetResponse";
import {PrintDepartureSheetReducer} from "./reducers/PrintDepartureSheetReducer";
import {FormattedMessage} from "react-intl";

const initialState = {
    stationList: [],
    isLoading: false,
    isSuccess: false,
    searchStation: "",
    targetStation: ""
};

/* Shows autocomplete station code chooser and
*  inflates result
* */
export const PrintDepartureSheetDialog = ({isModalOpen, onModelOpenChange, checkedDrivers}) => {
    const [{ isLoading, isSuccess, targetStation}] = useReducer(PrintDepartureSheetReducer, initialState);
    const closeModal = useCallback(() => onModelOpenChange(false), []);
    const [isCASProcessOngoing, setCASProcessOngoing] = useState(false);

    return (
        <Modal
            title={<FormattedMessage id="print.departure_sheet" defaultMessage="Print Departure Sheet"/>}
            open={isModalOpen}
            onClose={closeModal}
            scrollContainer="viewport"
            closeLabel="Close"
            width={500}>
            <Box height={100}>
                {!isLoading && !isSuccess &&
                <Box>
                    <Text type="h100"><FormattedMessage id="print.departure_sheet_confirmation"
                                                        defaultMessage="Click Confirm to print departure sheet"/></Text>
                    <br/>
                </Box>

                }
                {!isLoading && !isSuccess && !isCASProcessOngoing &&
                <ModalFooter>
                    <Row spacingInset="small" alignmentHorizontal="right" widths="fit">
                        <Button type="secondary" size="small" onClick={closeModal}>
                            Cancel
                        </Button>
                        <Button type="primary" size="small" onClick={() => setCASProcessOngoing(true)}>
                            Confirm
                        </Button>
                    </Row>
                </ModalFooter>
                }
                {isCASProcessOngoing && closeModal()}

                {!isLoading && isSuccess &&
                <Row alignmentHorizontal="center" alignmentVertical="center" height="100%">
                    <Loader type="circular"/>
                    <Text type="h200"><FormattedMessage id="print.departure_sheet_success"
                                                        defaultMessage="Departure sheet generated successfully"/></Text>
                </Row>
                }
                {isCASProcessOngoing &&
                <DepartureSheetResponse checkedDrivers={checkedDrivers}  targetStation={targetStation}/>}
            </Box>
        </Modal>
    );
};



// WEBPACK FOOTER //
// ./src/components/departureSheet/PrintDepartureSheetDialog.js